import muster from '@dbk-legacy/muster';
import { variable } from '@dbk-legacy/muster/helpers';
import { getValues } from '@dbk-legacy/muster/utils';
import moment from 'moment';
import Guid from '../utils/guid';
import { INVESTMENT_API_CODES } from '../constants'; 
import PdfDownload from '../utils/attachment-download';
import isValidJsonString from '../../src/utils/is-valid-json-string';
import convertDate from '../../src/utils/convertDate'

function parseDateFormat(content,messages){
 
  const clonedObject = JSON.parse(JSON.stringify(content))
  const currentLocalDate = moment(new Date())
  let newArrayAfterDate = []
  newArrayAfterDate = convertDate(currentLocalDate, clonedObject,messages);
 
  return newArrayAfterDate;
}

export default () =>{
  return muster()
    .path('investmentIdeas.getArticle', {
      call: async ({ req }, { get, set, call }) => {

        await set('investmentIdeas.articleContent', null);
        await set('investmentIdeas.attachmentFile', null);
        await set('investmentIdeas.isLoading', true);
        const guidStr = Guid();
        let articleId =  req.args[0];
        const [oReturn] = await getValues(get(`roster.data.investmentIdeas.getArticle.["i${articleId}"]["${guidStr}"]`));
        await set('investmentIdeas.isLoading', false);
        const [messages] = await getValues(get('i18n.messages'));
        
        isValidJsonString(oReturn).then(async (saveArticleResponse) => {
          if (saveArticleResponse) {
            if (saveArticleResponse.status.toUpperCase() === INVESTMENT_API_CODES.SUCCESS ) {
                const convertedInvestmentData = parseDateFormat(saveArticleResponse,messages)
                await set('investmentIdeas.articleContent', convertedInvestmentData);
              }
             else {
              await set('investmentIdeas.detailError', saveArticleResponse.errorMsg);
            }
          } else {
            await set('investmentIdeas.detailError', messages['app.investment.error.tryagain']);
          }
        }).catch(async () => {
          await set('investmentIdeas.detailError', messages['app.investment.error.tryagain']);
        });
       },
    })

    .path('investmentIdeas.getAttachment', {
      call: async ({ req }, { get, set, call }) => {
        const guidStr = Guid();
        let attachmentId =  req.args[0];
        const [oReturn] = await getValues(get(`roster.data.cioinsights.getAttachment.["i${attachmentId}"]["${guidStr}"]`));
        const [messages] = await getValues(get('i18n.messages'));

        isValidJsonString(oReturn).then(async (attachmentResponse) => {
          if (attachmentResponse) {
            if (attachmentResponse.status.toUpperCase() === INVESTMENT_API_CODES.SUCCESS ) {
                   await set('investmentIdeas.attachmentFile', attachmentResponse);
                   const isDownloaded = PdfDownload("InvestmentIdea", attachmentResponse.pdfData);
                   await set('investmentIdeas.showPdfModal', !isDownloaded);
              }
             else {
              await set('investmentIdeas.attachmentError', messages['app.investment.error.tryagain']);
            }
          } else {
            await set('investmentIdeas.attachmentError', messages['app.investment.error.tryagain']);
          }
        }).catch(async () => {
          await set('investmentIdeas.attachmentError', messages['app.investment.error.tryagain']);
        });
      },
    })

    .path('investmentIdeas.clearAttachment', {
      call: async ({ req }, { get, set, call }) => {
        await set('investmentIdeas.attachmentFile', null);
      },
    })

    .path('investmentIdeas.clearArticle', {
      call: async ({ req }, { get, set, call }) => {
        await set('investmentIdeas.articleContent', null);
        await set('investmentIdeas.attachmentFile', null);
      },
    })

    .path('investmentIdeas.attachmentFile', variable(null))
    .path('investmentIdeas.showPdfModal', variable(false))
    .path('investmentIdeas.articleContent', variable())
    .path('investmentIdeas.isLoading', variable(false))
    .path('investmentIdeas.detailError', variable(null))
    .path('investmentIdeas.attachmentError', variable(null));

    

}

